<template>
    <v-dialog 
        v-model="dialog" 
        max-width="600"
        persistent
        transition="dialog-bottom-transition"
    >
        <v-card class="warranty-modal-card">
            <!-- Close Button -->
            <v-btn 
                icon 
                large
                color="grey"
                @click="closeModal"
                class="close-button-fixed"
            >
                <v-icon size="24">mdi-close</v-icon>
            </v-btn>
            
            <!-- Header -->
            <v-card-title 
                class="warranty-header white--text d-flex align-center pa-6"
            >
                <div class="d-flex align-center">
                    <v-avatar color="white" size="48" class="mr-4">
                        <v-icon color="orange" size="28">mdi-alert-circle</v-icon>
                    </v-avatar>
                    <div>
                        <h2 class="text-h4 font-weight-bold mb-1">
                            Reklamation
                        </h2>
                        <p class="text-subtitle-1 mb-0 opacity-90">
                            Diese Bestellung enthält eine Reklamation
                        </p>
                    </div>
                </div>
            </v-card-title>

            <!-- Content -->
            <v-card-text class="pa-6">
                <div class="warranty-content">
                    <div class="warranty-reason-section">
                        <h3 class="text-h6 font-weight-bold mb-3 d-flex align-center">
                            <v-icon color="orange" class="mr-2">mdi-text-box</v-icon>
                            Grund der Reklamation
                        </h3>
                        <div class="warranty-reason-box">
                            {{ warrantyReason || 'Kein Grund angegeben' }}
                        </div>
                    </div>

                    <!-- Warranty Note Section (if available) -->
                    <div v-if="warrantyNote" class="warranty-note-section mt-4">
                        <h3 class="text-h6 font-weight-bold mb-3 d-flex align-center">
                            <v-icon color="orange" class="mr-2">mdi-note-text</v-icon>
                            Zusätzliche Notiz
                        </h3>
                        <div class="warranty-note-box">
                            {{ warrantyNote }}
                        </div>
                    </div>

                    <div class="warranty-info-section mt-4">
                        <v-alert
                            color="orange"
                            dark
                            class="mb-0"
                            icon="mdi-information"
                        >
                            <strong>Wichtiger Hinweis:</strong> 
                            Bitte überprüfen Sie die Bestellung sorgfältig vor dem Verpacken. 
                            Bei Reklamationen ist besondere Aufmerksamkeit erforderlich.
                        </v-alert>
                    </div>
                </div>
            </v-card-text>

            <!-- Actions -->
            <v-card-actions class="pa-6 pt-0">
                <v-spacer></v-spacer>
                <v-btn 
                    color="grey"
                    text
                    large
                    @click="closeModal"
                >
                    Verstanden
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: 'WarrantyModal',
    props: {
        warrantyReason: {
            type: String,
            default: ''
        },
        warrantyNote: {
            type: String,
            default: ''
        },
        currentOrder: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            dialog: true
        }
    },
    methods: {
        closeModal() {
            this.dialog = false;
            this.$emit('close-modal');
        }
    }
}
</script>

<style scoped>
.warranty-modal-card {
    position: relative;
    overflow: visible;
}

.close-button-fixed {
    position: absolute !important;
    top: 8px;
    right: 8px;
    z-index: 10;
    background-color: rgba(255, 255, 255, 0.9) !important;
}

.warranty-header {
    background: linear-gradient(135deg, #ff9800, #f57f17);
    border-radius: 4px 4px 0 0;
}

.warranty-content {
    max-width: 100%;
}

.warranty-reason-section,
.warranty-note-section {
    background-color: #fafafa;
    border-radius: 8px;
    padding: 16px;
    border-left: 4px solid #ff9800;
}

.warranty-reason-box,
.warranty-note-box {
    background-color: white;
    border: 1px solid #e0e0e0;
    border-radius: 6px;
    padding: 12px;
    font-size: 16px;
    line-height: 1.5;
    color: #333;
    min-height: 60px;
    word-wrap: break-word;
}

.warranty-info-section {
    margin-top: 16px;
}

/* Responsive adjustments */
@media (max-width: 600px) {
    .warranty-header {
        padding: 16px !important;
    }
    
    .warranty-header .text-h4 {
        font-size: 1.5rem !important;
    }
    
    .warranty-reason-section,
    .warranty-note-section {
        padding: 12px;
    }
    
    .warranty-reason-box,
    .warranty-note-box {
        padding: 10px;
        font-size: 14px;
    }
}
</style>
